import Model, { belongsTo, hasMany } from '@ember-data/model';

export default class SignInFieldPage extends Model {
  @belongsTo('flow', { async: false, inverse: 'signInFieldPage' }) flow;
  @hasMany('sign-in-field', { async: true, inverse: 'signInFieldPage' }) signInFields;
}
